/**
 * Koszt dostawy w podsumowaniu koszyka - PRAWDZIWE stawki ze sklepu.
 *
 * Shopify liczy wysylke tylko dla podanego adresu, bo jego silnik dostaw jest
 * przygotowany na wysylke do wielu krajow. W tym sklepie kraj jest jeden, a stawki
 * sa wagowe, wiec kwota nie zalezy od adresu - wystarczy odpytac Shopify z adresem
 * zastepczym i dostajemy dokladnie te stawki, ktore pokaze kasa.
 *
 * Dzieki temu w motywie NIE MA przepisanego cennika. Zmiana stawek w panelu jest
 * widoczna w koszyku od razu, bez dotykania kodu.
 *
 * Pokazujemy NAJTANSZA stawke plus jej nazwe. Drozsze (wniesienie, montaz) sa
 * wyborem kupujacego, nie niewiadoma - o tym mowi dopisek pod kwota.
 *
 * Gdy zapytanie sie nie uda, w wierszu ZOSTAJE napis zastepczy z Liquida
 * ("w kolejnym kroku"). Koszyk nigdy nie podaje kwoty, ktorej nie potwierdzil sklep.
 */
if (!customElements.get('cart-shipping')) {
  class CartShipping extends HTMLElement {
    connectedCallback() {
      /* Element jest przerysowywany razem z szuflada i strona koszyka, wiec
         connectedCallback pelni role "odswiez sie po zmianie koszyka". */
      this.note = this.closest('[data-cart-summary]')?.querySelector('[data-cart-shipping-note]');
      if (this.dataset.items === '0') return;
      this.load();
    }

    get cacheKey() {
      const d = this.dataset;
      return `cossy-shipping:${d.country}:${d.zip}:${d.weight}:${d.items}`;
    }

    async load() {
      /* Ten sam koszyk pytamy raz na sesje - przy kazdym otwarciu szuflady leciałoby
         inaczej nowe zapytanie, a stawki dla tej samej wagi sie nie zmieniaja. */
      const cached = sessionStorage.getItem(this.cacheKey);
      if (cached) {
        this.render(JSON.parse(cached));
        return;
      }

      const rate = await this.fetchCheapest();
      if (!rate) return;
      try {
        sessionStorage.setItem(this.cacheKey, JSON.stringify(rate));
      } catch (e) {
        /* tryb prywatny albo pelny magazyn - brak zapisu nie przeszkadza */
      }
      this.render(rate);
    }

    async fetchCheapest() {
      const { country, zip } = this.dataset;
      if (!country || !zip) return null;

      const query = new URLSearchParams({
        'shipping_address[country]': country,
        'shipping_address[zip]': zip,
      });

      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      try {
        const response = await fetch(`${root}cart/shipping_rates.json?${query}`);
        if (!response.ok) return null;
        const data = await response.json();
        const rates = data.shipping_rates || [];
        if (!rates.length) return null;

        return rates.reduce((best, r) => (parseFloat(r.price) < parseFloat(best.price) ? r : best));
      } catch (e) {
        return null;
      }
    }

    render(rate) {
      /* Kwoty z tego zapytania przychodza w jednostkach glownych ("129.00"), a formater
         motywu przyjmuje dokladnie taka postac (sam mnozy przez sto) i uzywa formatu
         waluty ze sklepu - dzieki temu kwota wyglada jak wszystkie inne w motywie. */
      const amount = parseFloat(rate.price);
      this.textContent = window.theme && window.theme.formatMoney
        ? window.theme.formatMoney(amount)
        : `${amount.toLocaleString('pl-PL')} ${window.Shopify.currency.active}`;

      if (!this.note) return;
      /* Tresc dopisku jest w plikach jezykowych, a nazwa uslugi przychodzi ze sklepu -
         Liquid wstawia wzorzec z miejscem na nazwe, tutaj tylko je wypelniamy. */
      const template = this.note.dataset.template || '';
      this.note.textContent = template.replace('__NAME__', rate.presentment_name || rate.name);
      this.note.hidden = false;
    }
  }

  customElements.define('cart-shipping', CartShipping);
}
